<template>
  <div class="my-listing-navigations">
    <Menu :active-name="activeItem" @on-select="handleOnSelectMenuItem">
      <MenuItem name="general">
        <Icon type="ios-radio-button-on" size="10"/>
        General
      </MenuItem>
      <MenuItem name="about">
        <Icon type="ios-radio-button-on" size="10"/>
        About
      </MenuItem>
      <MenuItem name="overview">
        <Icon type="ios-radio-button-on" size="10"/>
        Overview
      </MenuItem>
      <MenuItem name="location">
        <Icon type="ios-radio-button-on" size="10"/>
        Location
      </MenuItem>
      <MenuItem name="categories">
        <Icon type="ios-radio-button-on" size="10"/>
        Categories
      </MenuItem>
      <MenuItem name="video">
        <Icon type="ios-radio-button-on" size="10"/>
        Video
      </MenuItem>
      <MenuItem name="gallery">
        <Icon type="ios-radio-button-on" size="10"/>
        Gallery
      </MenuItem>
      <MenuItem name="references">
        <Icon type="ios-radio-button-on" size="10"/>
        References
      </MenuItem>
      <MenuItem name="events">
        <Icon type="ios-radio-button-on" size="10"/>
        Event(s)
      </MenuItem>
      <MenuItem name="social-networks">
        <Icon type="ios-radio-button-on" size="10"/>
        Social Networks
      </MenuItem>
      <MenuItem name="responsible-company">
        <Icon type="ios-radio-button-on" size="10"/>
        Responsible Company
      </MenuItem>
    </Menu>
  </div>
</template>

<script>

export default {
  data () {
    return {
      activeItem: 'general'
    }
  },

  methods: {
    handleOnSelectMenuItem (val) {
      this.activeItem = val
      this.$emit('scroll', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.my-listing-navigations {
  position: fixed;
  top: 50%;
  left: 0px;
  transform: translate(0%, -45%);
  .ivu-menu {
    background: transparent;
    &::after {
      display: none;
    }
    .ivu-menu-item {
      .ivu-icon {
        font-size: 10px;
        border: 1px solid transparent;
        border-radius: 50%;
        padding: 2px;
      }
      &:hover {
        color: #000000;
        font-weight: bold;
        .ivu-icon {
          border: 1px solid #999999;
        }
      }
      &.ivu-menu-item-active {
        color: #000000;
        font-weight: bold;
        background: transparent;
        &::after {
          display: none;
        }
        .ivu-icon {
          border: 1px solid #999999;
        }
      }
    }
  }
}
</style>
